import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { OffboardingService } from '../offboarding.service';

@Component({
  selector: 'app-offboarding-requirements-details',
  templateUrl: './offboarding-requirements-details.component.html',
  styleUrls: ['./offboarding-requirements-details.component.scss']
})
export class OffboardingRequirementsDetailsComponent implements OnInit {
  offboardingRolesSet = {};
  company = [];
  roles = [];
  isLoading = true;

  constructor(
    private router: Router,
    private offboardingService: OffboardingService,
  ) {
    this.company.push(decodeURIComponent(this.router.url.split('/')[2]));
  }

  ngOnInit(): void {
    this.getOffboardingRoles();
  }

  getOffboardingRoles() {
    this.isLoading = true;
    this.roles = [];
    this.offboardingRolesSet = {};
    this.offboardingService.getAllRoles()
      .subscribe(v => {
        v.data.offboardingRoles.edges.map(value => {
          if (this.offboardingRolesSet[value.node.company.id]?.length) {
            this.offboardingRolesSet[value.node.company.id].push({
              id: value.node.id,
              companyId: value.node.company.id,
              name: value.node.name,
              updatedAt: value.node.updatedAt,
              createdAt: value.node.createdAt,
              actions: value.node.actions.map(item =>
                value.node.actions.length ? item.description : []
              ),
            });
          } else {
            this.offboardingRolesSet[value.node.company.id] = [{
              id: value.node.id,
              companyId: value.node.company.id,
              name: value.node.name,
              updatedAt: value.node.updatedAt,
              createdAt: value.node.createdAt,
              actions: value.node.actions.map(item =>
                value.node.actions.length ? item.description : []
              ),
            }];
          }
        });
        this.roles = this.getPreparedOffboardingRoles();
        this.isLoading = false;
      });
  }

  getPreparedOffboardingRoles() {
    const raw = this.company.map(v => this.offboardingRolesSet[v]).filter(v => !!v);
    if (raw.length) {
      let result = [];
      raw.map(v => {
        result = result.concat(v);
      });
      return result;
    } else {
      return [];
    }
  }

  manageOffboardingRequests(res) {
    if (res) {
      res.data.map(value => {
        const input = {
          companyId: '',
          name: value.name,
          actions: value.actions
        };
        if (value?.needCreate) {
          value.companyId.map(id => {
            input.companyId = id;
            this.offboardingService.createRole(input).subscribe(role => {
              const newRole = {
                id: role.data.createOffboardingRole.offboardingRole.id,
                companyId: role.data.createOffboardingRole.offboardingRole.company.id,
                name: role.data.createOffboardingRole.offboardingRole.name,
                updatedAt: role.data.createOffboardingRole.offboardingRole.updatedAt,
                createdAt: role.data.createOffboardingRole.offboardingRole.createdAt,
                actions: role.data.createOffboardingRole.offboardingRole.actions.map(item =>
                  role.data.createOffboardingRole.offboardingRole.actions.length ? item.description : []
                ),
              };
              if (this.offboardingRolesSet[id]) {
                this.offboardingRolesSet[id].push(newRole);
              } else {
                this.offboardingRolesSet[id] = [newRole];
              }
              this.roles = this.getPreparedOffboardingRoles();
            });
          });
        } else if (value?.needUpdate) {
          input.companyId = value.companyId;
          this.offboardingService.updateRole(value.id, input).subscribe(result => {
            this.offboardingRolesSet[value.companyId] = this.offboardingRolesSet[value.companyId].map(role => {
              if (role.id === result.data.updateOffboardingRole.offboardingRole.id) {
                return {
                  id: result.data.updateOffboardingRole.offboardingRole.id,
                  companyId: result.data.updateOffboardingRole.offboardingRole.company.id,
                  name: result.data.updateOffboardingRole.offboardingRole.name,
                  updatedAt: result.data.updateOffboardingRole.offboardingRole.updatedAt,
                  createdAt: result.data.updateOffboardingRole.offboardingRole.createdAt,
                  actions: result.data.updateOffboardingRole.offboardingRole.actions.map(item =>
                    result.data.updateOffboardingRole.offboardingRole.actions.length ? item.description : []
                  )
                };
              } else {
                return role;
              }
            });
          });
        }
      });

      if (res.needsToBeDeleted && res.needsToBeDeleted.length) {
        res.needsToBeDeleted.map((item) => {
          this.offboardingService.deleteRole(item.id).subscribe(role => {
            if (role.data.deleteOffboardingRole.ok) {
              this.offboardingRolesSet[item.companyId] =
                this.offboardingRolesSet[item.companyId].filter(v => v.id !== item.id);
            }
          });
        });
      }
    }
  }
}
